import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-header primary-bg", { simple: $props.simple }])
  }, [
    (!$setup.isRealHide)
      ? (_openBlock(), _createBlock(_component_BaseIcon, {
          key: 0,
          name: "ic-back",
          alt: "",
          color: "#fff",
          onClick: $setup.back
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, _toDisplayString($props.title), 1)
  ], 2))
}